import * as Yup from "yup";

export const companyInfoValidationSchema = Yup.object({
  name: Yup.string()
    .required("Company name is required")
    .min(2, "Company name must be at least 2 characters"),

  email: Yup.string()
    .required("Company email is required")
    .trim()
    .lowercase()
    .email("Enter a valid email address")
    .max(254, "Email is too long"),

  portalName: Yup.string()
    .required("Portal name is required")
    .min(2, "Portal name must be at least 2 characters"),

  industry: Yup.string().required("Please select an industry"),

  phoneNumber: Yup.string()
    .required("Phone number is required")
    .min(7, "Phone number is too short"),
});
